import PublicIncident from "../../components/screens/publicIncident";
import React from 'react';


function PublicIncidentScreen() {
  return (
    <div>
      <PublicIncident />
    </div>
  );
}

export default PublicIncidentScreen;